'use client'

/**
 * One project's page.
 *
 * The route resolves the `params` promise and hands the id down; everything else — the
 * loading state, the not-found copy, the back link — is this domain's (ADR 0010).
 */

import Link from 'next/link'
import { useProjects } from './select-projects'
import { ProjectDetail } from './project-detail'

export function ProjectPage({ id }: { id: string }) {
  const { data: projects, isLoading } = useProjects()

  if (isLoading) {
    return (
      <div className="mx-auto w-full max-w-3xl py-12 text-center">
        <p className="text-muted-foreground text-sm">Loading project...</p>
      </div>
    )
  }

  const project = projects.find((p) => p.id === id)

  if (!project) {
    return (
      <div className="mx-auto w-full max-w-3xl py-12 text-center">
        <p className="text-foreground text-sm font-medium">Project not found</p>
        <p className="text-muted-foreground mt-1 text-sm">
          This project may have been deleted or archived.
        </p>
        <Link
          href="/app/projects"
          className="text-muted-foreground hover:text-foreground focus-visible:ring-ring mt-4 inline-block rounded-sm text-sm underline transition-colors focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none"
        >
          Back to projects
        </Link>
      </div>
    )
  }

  return <ProjectDetail project={project} />
}
